module.exports = __webpack_public_path__ + "assets/img/i_medium.f46228dc.png";